import { connect } from "react-redux"

import { setIdentityConsent } from "../store/survey.actions"
import { getOptionalUserEmail } from "../store/survey.selectors"

const mapState = state => ({
  optionalUserEmail: getOptionalUserEmail(state)
})

const mapDispatch = dispatch => ({
  setIdentityConsent: payload => dispatch(setIdentityConsent(payload))
})

const forcedIdentityConsentContainer = connect(mapState, mapDispatch)

export default forcedIdentityConsentContainer
